import React from "react";
import Navbar from "./components/Navbar";
import AboutUs from "./components/AboutUs";
import Footer from "./components/Footer";
function App() {
  return (
    <div className="">
      <div className="bg-indigo-500">
        <Navbar />
        {/* AboutUs start */}
        <AboutUs></AboutUs>

        {/* AboutUs end */}
        <Footer></Footer>
      </div>
    </div>
  );
}

export default App;
